import {
  SET_CONFIG_LIST,
  SET_CHECK_GIB_SELLER_INFO_DATA,
  SET_CHECK_NEED_PASSWORD_CHANGE,
  SET_TOASTER_DATA,
  SET_UPLOAD_IMAGE_SUCCESS,
  TRIGGER_DEAL_TABLE_REFRESH,
  SET_CUSTOM_DEAL_NOTIFICATION,
} from "./mutation-types";

export default {
  [SET_CONFIG_LIST](state, data) {
    state.configList = data;
  },
  [SET_CHECK_GIB_SELLER_INFO_DATA](state, data) {
    state.checkGIBSellerInfoData = data;
  },
  [SET_CHECK_NEED_PASSWORD_CHANGE](state, data) {
    state.needsPasswordChange = data;
  },
  [SET_TOASTER_DATA](state, payload) {
    state.toasterData = payload;
  },
  [SET_UPLOAD_IMAGE_SUCCESS](state, payload) {
    state.hasImageError = payload;
  },
  [TRIGGER_DEAL_TABLE_REFRESH](state,payload) {
    state.dealTableRefreshKey = payload;
  },
  [SET_CUSTOM_DEAL_NOTIFICATION](state, data) {
    state.hasCustomDealNotification = data;
  },
};
